var map = {
	"./activity_brands/activity_summer.jpg": "f45b",
	"./activity_brands/chuangwei.jpg": "968b",
	"./activity_brands/festival.jpg": "2f8a",
	"./activity_brands/gekanuo.jpg": "75e3",
	"./activity_brands/kabaoou.png": "9903",
	"./activity_brands/kangjia.jpg": "aeea",
	"./activity_brands/meiling.jpg": "ab3a",
	"./activity_brands/recommend_bg.png": "b16a",
	"./activity_brands/shenghuo.png": "e5fc",
	"./activity_brands/spring.png": "2fc3",
	"./activity_brands/taihuangzi.png": "3e4c",
	"./activity_brands/temai.jpg": "3153",
	"./activity_brands/wine.jpg": "99f7",
	"./activity_brands/winter.png": "596a",
	"./activity_brands/xiliniu.jpg": "124f",
	"./activity_brands/yimi.jpg": "10e5",
	"./activity_brands/zhigao.jpg": "dce6",
	"./activity_entries/bargain.png": "eeb5",
	"./activity_entries/point.png": "766f",
	"./activity_entries/point_jindou.png": "f495",
	"./activity_entries/returnscore.png": "07a9",
	"./activity_entries/returnscore_jindou.png": "6e8d",
	"./activity_entries/shenghuo.png": "35db",
	"./activity_entries/shenghuo_duihuan.png": "f916",
	"./activity_entries/statement.png": "4d75e",
	"./activity_entries/timelimit.png": "56b7",
	"./bannerFloat2.png": "3492",
	"./baozhang.png": "a0ee",
	"./bgshadow.png": "0f5e",
	"./brand-title.png": "e2d4",
	"./centerWineDialogImg.png": "c291",
	"./close.png": "3194",
	"./downloadApp.png": "15fe",
	"./dui.png": "fe39",
	"./duiduoduo.png": "a623",
	"./duiduoduo_wxPub.png": "0dc9",
	"./duihaoli.png": "9b88",
	"./duihaoli_wxPub.png": "f3f2",
	"./dw.png": "bbf4",
	"./expire.png": "2afb",
	"./expire_bg.png": "1c17",
	"./fangxingou.png": "fc8d",
	"./favicon/logo.png": "098c",
	"./fireworks.gif": "b39c",
	"./foot/point.png": "8db7",
	"./foot/timeLimit.png": "68db",
	"./footbar/home@2x.png": "3448",
	"./footbar/home_active@2x.png": "6ca1",
	"./footbar/home_click_nianhuo@2x.png": "0eee",
	"./footbar/integral_click_nianhuo@2x.png": "3b17",
	"./footbar/my_click_nianhuo@2x.png": "ccb7",
	"./footbar/nianhuo@2x.png": "9635",
	"./footbar/nianhuo_click@2x.png": "47af",
	"./footbar/order@2x.png": "e125",
	"./footbar/order_active@2x.png": "27c9",
	"./footbar/order_click@2x.png": "a95f",
	"./footbar/order_click_nianhuo@2x.png": "cdfe",
	"./footbar/pointscenter@2x.png": "e7bf",
	"./footbar/rank@2x.png": "8a90",
	"./footbar/rank_active@2x.png": "f987",
	"./footbar/usercenter@2x.png": "734f",
	"./footbar/usercenter_active@2x.png": "dfdb",
	"./fuchuang.png": "f8dd",
	"./ganbei.png": "cd37",
	"./get_coupon_success.png": "bbc7",
	"./goodsDetail/bannerFloat2.png": "f83a",
	"./goodsDetail/fangxingou.png": "567a",
	"./goodsDetail/jf1.png": "26ff",
	"./goodsDetail/jf2.png": "cc15",
	"./goodsDetail/jf3.png": "231b",
	"./goodsDetail/jf4.png": "f9d1",
	"./goodsDetail/jf5.png": "623e",
	"./goodsDetail/jf6.png": "e541",
	"./goodsDetail/jf7.png": "c8fc",
	"./goodsDetail/jf8.png": "78ce",
	"./goodsDetail/jf9.png": "91b0",
	"./goodsDetail/priceBanner_1.png": "ea79",
	"./goodsDetail/priceBanner_default.png": "1e52",
	"./goodsDetail/priceBanner_drawPrize.png": "e45f",
	"./goodsDetail/priceBanner_payOnDelivery.png": "4b34",
	"./goodsDetail/priceBanner_payOnDeliveryFreeReceive.png": "43ca",
	"./goodsList_loading_duiduoduo.png": "df65",
	"./goodsList_loading_duihaoli.png": "1272",
	"./goodsList_loading_jinridui.png": "06b4",
	"./goodsList_loading_taopin.png": "5007",
	"./goods_list_more_cell_duihuan.png": "7007",
	"./goods_list_more_cell_jifen.png": "35d3",
	"./goods_profile_header_info_coupon_bg.png": "63c8",
	"./guanZhuYouLi_tpyx.png": "6fce",
	"./home_brands/chuangwei.jpg": "00ef",
	"./home_brands/gekanuo.jpg": "88ae",
	"./home_brands/kabaoou.png": "9c13",
	"./home_brands/kangjia.jpg": "e2f7",
	"./home_brands/meiling.jpg": "1af5",
	"./home_brands/taihuangzi.png": "5fee",
	"./home_brands/xiliniu.jpg": "8d08",
	"./home_brands/yimi.jpg": "a62d",
	"./home_brands/zhigao.jpg": "704a",
	"./home_capsule/FMCG_capsule.gif": "8078",
	"./home_capsule/rush_buy_capsule.gif": "9b8c",
	"./home_capsule/spring_festival.gif": "15be",
	"./home_capsule/wine_capsule.gif": "390f",
	"./home_entrance/gift.png": "538a",
	"./home_entrance/hot.png": "5bab",
	"./home_entrance/life.png": "c107",
	"./home_entrance/live.gif": "15ea",
	"./home_entrance/point.gif": "d0bb",
	"./home_entrance/point_1.png": "c78a",
	"./home_entrance/point_2.png": "3181",
	"./home_entrance/returnScore.png": "52ff",
	"./home_entrance/timelimit.gif": "1452",
	"./home_entrance/wine2.png": "7310",
	"./home_header_bottom.png": "dcba",
	"./home_header_logo_duiduoduo.png": "05ac",
	"./home_header_logo_duihaoli.png": "cd5c",
	"./home_header_logo_jinridui.png": "86e8",
	"./home_header_logo_taopin.png": "970d",
	"./home_header_top.png": "c932",
	"./hottitle.png": "da37",
	"./icon-choose.png": "0f54",
	"./icon-shield.png": "fc22",
	"./icon/delete_icon@2x.png": "2f59",
	"./icon/hot_icon@2x.png": "a731",
	"./icon/icon-life@2x.png": "db38",
	"./icon/icon-more@2x.png": "87de",
	"./icon/icon-postage.png": "0655",
	"./icon/icon-quality.png": "a87d",
	"./icon/icon-rank@2x.png": "08c1",
	"./icon/icon-return@2x.png": "41b3",
	"./icon/icon-spring.png": "d3d8",
	"./icon/icon-summer@2x.png": "97b5",
	"./icon/icon-time@2x.png": "94d7",
	"./icon/icon-week.png": "4cd9",
	"./icon/icon-wine@2x.png": "2230",
	"./icon/icon-winter.png": "19fb",
	"./icon/medal_other.png": "62b1",
	"./icon/medal_top1.png": "3b5c",
	"./icon/medal_top2.png": "8670",
	"./icon/medal_top3.png": "9961",
	"./icon/rac.png": "b4f1",
	"./icon/top1ticket_icon@2x.png": "9e3b",
	"./icon/top2ticket_icon@2x .png": "d710",
	"./icon/top3ticket_icon@2x.png": "f694",
	"./jiayipeishi.png": "65ff",
	"./jinri.png": "a5ab",
	"./jinridui.png": "6229",
	"./kefu1.jpg": "c59a",
	"./kefu2.jpg": "8a2d",
	"./kefu2.png": "ee41",
	"./kefu3.jpg": "0c76",
	"./kefu4.jpg": "f3b2",
	"./kefu5.jpg": "ed7a",
	"./kefuTop.jpg": "dff3",
	"./laba02.gif": "1809",
	"./labourDay/header.png": "a42b",
	"./labourDay/home_capsule.gif": "7d9c",
	"./loading_duiduoduo.gif": "2ec6",
	"./loading_duihaoli.gif": "abc1",
	"./loading_jinridui.gif": "7b36",
	"./loading_taopin.gif": "31ac",
	"./logo.png": "c9a0",
	"./money.png": "e2dc",
	"./my/BJ.png": "bfed",
	"./my/card-bg.png": "d009",
	"./my/mine_bg.png": "e2af",
	"./my/quduihuan.png": "1121",
	"./my/userPhoto.png": "c4c9",
	"./new_goods.png": "faec",
	"./oderSuccess_packet.png": "d64f",
	"./order/bg_notfound.png": "76ad",
	"./order/bg_search.png": "9e26",
	"./order/dingdan.png": "f852",
	"./order/order_header_bg.png": "ca3b",
	"./order/order_on@2x.png": "720d",
	"./order/order_under@2x.png": "6638",
	"./order/queryOrderGuide.gif": "dee4",
	"./order/search.png": "0571",
	"./orderProtect.png": "f8f3",
	"./orderSuccess_draw.png": "8c67",
	"./orderSuccess_kefuGuide.png": "d31a",
	"./payOnDelivery_guideWelfare.gif": "27c8",
	"./point_center/jifen_banner@2x.png": "e2eb",
	"./present_point_again_img.gif": "1e3b",
	"./present_point_img.gif": "9a16",
	"./privateGuide_bg.png": "4575",
	"./qitian.png": "17b0",
	"./radio1.png": "1fef",
	"./rank_bg.png": "958c",
	"./rank_bg_red.png": "5881",
	"./returnScore/detailHint.jpg": "683e",
	"./returnScore/flame.png": "ef86",
	"./returnScore/label.jpg": "cc24",
	"./returnScore/rule.png": "79fe",
	"./returnScore/topBackground.jpg": "d99b",
	"./ring.svg": "9477",
	"./rushBuy/header.png": "41d4",
	"./search.png": "e844",
	"./singleProductActivity/bg_baopin.png": "db52",
	"./singleProductActivity/bg_point.png": "fb5b",
	"./singleProductActivity/bg_time.png": "717d",
	"./springFestival/bg.png": "f858",
	"./springFestival/header.png": "9882",
	"./springFestival/header_bg.jpg": "8669",
	"./tabBg/tab_active_0.png": "bc52",
	"./tabBg/tab_active_1.png": "4e30",
	"./tabBg/tab_active_2.png": "bca9",
	"./tabBg/tab_active_3.png": "17ef",
	"./tabBg/tab_active_4.png": "e635",
	"./tab_bg.png": "b37e",
	"./tab_bg@2x.png": "2264",
	"./taopin.png": "8108",
	"./themes/common/activity_entry_point_dh.png": "821b",
	"./themes/common/activity_entry_returnscore.png": "d4a3",
	"./themes/common/goods_list_more_cell_duihuan.png": "279c",
	"./themes/common/home_entrance_exchange_1.png": "dbd96",
	"./themes/common/home_entrance_exchange_2.png": "deff",
	"./themes/common/home_swipe_returnscore_jinri.png": "7a97",
	"./themes/common/priceBanner_dh_mohu.png": "6b08",
	"./themes/common/returnScore_topBackground_jinri_credit.png": "6a5c",
	"./themes/common/wxpubTutorial_bg_duiduoduo.png": "02ca",
	"./themes/common/wxpubTutorial_bg_duihaoli.png": "2f01",
	"./themes/coupon/home_entrance_exchange_1.png": "cb8c",
	"./themes/coupon/home_entrance_exchange_2.png": "2c02",
	"./themes/credit/home_entrance_exchange_1.png": "5ae6",
	"./themes/credit/home_entrance_exchange_2.png": "534b",
	"./themes/credit/theme_one_icon.svg": "4c08",
	"./timeLimit/banner.jpg": "0c6a",
	"./timeLimit/linepoint@2x.png": "6c2c",
	"./timeLimit/lowest.png": "e2b5",
	"./timeLimit/specialPrice.png": "f770",
	"./timeLimit/superdeal@2x.png": "6327",
	"./timeLimit/topBackground.jpg": "92c4",
	"./videoLive/bg.jpg": "2cee",
	"./videoLive/chuangwei_banner.png": "e8c9",
	"./videoLive/living_banner.png": "1ff8",
	"./videoLive/living_taopin.png": "25a0",
	"./videoLive/zhibogif.gif": "8f8d",
	"./wechatShare/returnScore.png": "965b",
	"./wechatShare/timeLimit.png": "0d28",
	"./weixin2.png": "d82e",
	"./wx05.png": "a134",
	"./wx06.png": "9588",
	"./wxShareMask.png": "9c12",
	"./wxpubTutorial/bg_tpyx.png": "b325",
	"./wxpubTutorial/copyName.png": "4f88",
	"./wxpubTutorial/saveQrcode.png": "0ae1",
	"./zfb2.png": "dbd9",
	"./zfb_hui.png": "7444",
	"./zhuanpan.png": "b16c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d979";